module.exports = __webpack_public_path__ + "img/flow.7c810ac9.svg";